import { LABELS, MESSAGES } from '../../constants';
import { AlertsList } from '../Alerts';
import { reportError } from '../../api';
import { useEffect } from 'react';

export const EmptyProductsFallback = ({ productBrowseData }) => {
    const [apps, store, _, customerNumber, schoolName] = window.location.pathname
        .split('/')
        .filter(Boolean);
    const previousPageURL = productBrowseData?.homewardPathSegments?.[1]?.url;
    const previousPageFallbackURL = `${apps}/${store}/customer/${customerNumber}/${schoolName}`;
    const isPbDataAvailable = Boolean(productBrowseData && Object.values(productBrowseData).length);

    useEffect(() => {
        //! Added this condition to be sure that we can send error details to the bummer.mvc
        //! As initially pbData will be empty array for the first render and will be filled on useEffect
        //! After re render it should contain necessary data where we will be able to check the products amount
        if(isPbDataAvailable){
            const options = {
                customerNumber: customerNumber,
                appCustomer: "product-browse-ui",
                src: window.location.href,
                occTimestamp: new Date().toString(),
                appEnvironment: navigator.userAgent,
                faultDetails: MESSAGES.NO_PRODUCTS_AVAILABLE
            };
            reportError(options)
        }
    }, [isPbDataAvailable])

    return isPbDataAvailable && (
        <div className='d-flex flex-column empty-products-fallback-container'>
            <AlertsList messages={[{ message: MESSAGES.NO_PRODUCTS_AVAILABLE }]} />
            <div className='d-flex justify-content-center'>
                <a
                    href={previousPageURL || previousPageFallbackURL}
                    className='btn btn-primary'
                >
                    {LABELS.RETURN_BACK}
                </a>
            </div>
        </div>
    )
}